class UpgradeModel {
    constructor(upgradeModel?: UpgradeModel) {
        this.addressId = upgradeModel ? upgradeModel.addressId == undefined ? '' : upgradeModel.addressId : '';
        this.leadCategoryId = upgradeModel ? upgradeModel.leadCategoryId == undefined ? '' : upgradeModel.leadCategoryId : '';
        this.sourceId = upgradeModel ? upgradeModel.sourceId == undefined ? null : upgradeModel.sourceId : null;
        this.siteTypeId = upgradeModel ? upgradeModel.siteTypeId == undefined ? '' : upgradeModel.siteTypeId : '';
        this.currentAddressId = upgradeModel ? upgradeModel.currentAddressId == undefined ? '' : upgradeModel.currentAddressId : '';
        this.titleId = upgradeModel ? upgradeModel.titleId == undefined ? null : upgradeModel.titleId : null;
        this.firstName = upgradeModel ? upgradeModel.firstName == undefined ? '' : upgradeModel.firstName : '';
        this.lastName = upgradeModel ? upgradeModel.lastName == undefined ? '' : upgradeModel.lastName : '';
        this.customerId = upgradeModel ? upgradeModel.customerId == undefined ? '' : upgradeModel.customerId : '';
        this.leadGroupId = upgradeModel ? upgradeModel.leadGroupId == undefined ? '' : upgradeModel.leadGroupId : '';
        this.notes = upgradeModel ? upgradeModel.notes == undefined ? '' : upgradeModel.notes : '';
        this.callInitiationId = upgradeModel ? upgradeModel.callInitiationId == undefined ? '' : upgradeModel.callInitiationId : '';
        this.fromComponent = upgradeModel ? upgradeModel.fromComponent == undefined ? '' : upgradeModel.fromComponent : '';
    }
    leadGroupId: string;
    addressId: string;
    currentAddressId: string;
    sourceId: string;
    siteTypeId: string;
    leadCategoryId: string;
    titleId: number;
    firstName: string;
    lastName: string;
    customerId: string;
    notes: string;
    callInitiationId: string;
    fromComponent?:string;
}
class RelocationModel {
    constructor(relocationModel?: RelocationModel) {
        this.provinceName = relocationModel ? relocationModel.provinceName == undefined ? '' : relocationModel.provinceName : '';
        this.cityName = relocationModel ? relocationModel.cityName == undefined ? '' : relocationModel.cityName : '';
        this.postalCode = relocationModel ? relocationModel.postalCode == undefined ? '' : relocationModel.postalCode : '';
        this.buildingName = relocationModel ? relocationModel.buildingName == undefined ? '' : relocationModel.buildingName : '';
        this.buildingNumber = relocationModel ? relocationModel.buildingNumber == undefined ? '' : relocationModel.buildingNumber : '';
        this.suburbName = relocationModel ? relocationModel.suburbName == undefined ? '' : relocationModel.suburbName : '';
        this.locationPin = relocationModel ? relocationModel.locationPin == undefined ? '' : relocationModel.locationPin : '';
        this.streetName = relocationModel ? relocationModel.streetName == undefined ? '' : relocationModel.streetName : '';
        this.streetNo = relocationModel ? relocationModel.streetNo == undefined ? '' : relocationModel.streetNo : '';
        this.reprovince = relocationModel ? relocationModel.reprovince == undefined ? '' : relocationModel.reprovince : '';
        this.recity = relocationModel ? relocationModel.recity == undefined ? '' : relocationModel.recity : '';
        this.repostalCode = relocationModel ? relocationModel.repostalCode == undefined ? '' : relocationModel.repostalCode : '';
        this.rebuildingName = relocationModel ? relocationModel.rebuildingName == undefined ? '' : relocationModel.rebuildingName : '';
        this.rebuildingNumber = relocationModel ? relocationModel.rebuildingNumber == undefined ? '' : relocationModel.rebuildingNumber : '';
        this.resuburb = relocationModel ? relocationModel.resuburb == undefined ? '' : relocationModel.resuburb : '';
        this.relocationPin = relocationModel ? relocationModel.relocationPin == undefined ? '' : relocationModel.relocationPin : '';
        this.restreetAddress = relocationModel ? relocationModel.restreetAddress == undefined ? '' : relocationModel.restreetAddress : '';
        this.restreetNumber = relocationModel ? relocationModel.restreetNumber == undefined ? '' : relocationModel.restreetNumber : '';
        this.formatedAddress = relocationModel ? relocationModel.formatedAddress == undefined ? '' : relocationModel.formatedAddress : '';
        this.readdressId = relocationModel ? relocationModel.readdressId == undefined ? '' : relocationModel.readdressId : '';
        this.customerId = relocationModel ? relocationModel.customerId == undefined ? '' : relocationModel.customerId : '';
        this.isAddressComplex = relocationModel ? relocationModel.isAddressComplex == undefined ? false : relocationModel.isAddressComplex : false;
        this.isAddressExtra = relocationModel ? relocationModel.isAddressExtra == undefined ? false : relocationModel.isAddressExtra : false;
        this.isAfrigisSearch = relocationModel ? relocationModel.isAfrigisSearch == undefined ? false : relocationModel.isAfrigisSearch : false;
        this.estateName = relocationModel ? relocationModel.estateName == undefined ? '' : relocationModel.estateName : '';
        this.estateStreetNo = relocationModel ? relocationModel.estateStreetNo == undefined ? '' : relocationModel.estateStreetNo : '';
        this.estateStreetName = relocationModel ? relocationModel.estateStreetName == undefined ? '' : relocationModel.estateStreetName : '';
        this.addressConfidentLevel = relocationModel ? relocationModel.addressConfidentLevel == undefined ? '' : relocationModel.addressConfidentLevel : '';
        this.IsLSSScheme = relocationModel ? relocationModel.IsLSSScheme == undefined ? false : relocationModel.IsLSSScheme : false;
        this.addressConfidentLevelName = relocationModel ? relocationModel.addressConfidentLevelName == undefined ? '' : relocationModel.addressConfidentLevelName : '';
        this.addressConfidentLevelId = relocationModel ? relocationModel.addressConfidentLevelId == undefined ? '' : relocationModel.addressConfidentLevelId : '';
        this.provinceId = relocationModel ? relocationModel.provinceId == undefined ? '' : relocationModel.provinceId : '';
        this.cityId = relocationModel ? relocationModel.cityId == undefined ? '' : relocationModel.cityId : '';
        this.suburbId = relocationModel ? relocationModel.suburbId == undefined ? '' : relocationModel.suburbId : '';
        this.leadGroupId = relocationModel ? relocationModel.leadGroupId == undefined ? '' : relocationModel.leadGroupId : '';
        this.seoId = relocationModel ? relocationModel.seoId == undefined ? '' : relocationModel.seoId : '';
        this.addressId = relocationModel ? relocationModel.addressId == undefined ? '' : relocationModel.addressId : '';
        this.leadCategoryId = relocationModel ? relocationModel.leadCategoryId == undefined ? '' : relocationModel.leadCategoryId : '';
        this.sourceId = relocationModel ? relocationModel.sourceId == undefined ? null : relocationModel.sourceId : null;
        this.siteTypeId = relocationModel ? relocationModel.siteTypeId == undefined ? null : relocationModel.siteTypeId : null;
        this.currentAddressId = relocationModel ? relocationModel.currentAddressId == undefined ? '' : relocationModel.currentAddressId : '';
        this.titleId = relocationModel ? relocationModel.titleId == undefined ? '' : relocationModel.titleId : '';
        this.firstName = relocationModel ? relocationModel.firstName == undefined ? '' : relocationModel.firstName : '';
        this.lastName = relocationModel ? relocationModel.lastName == undefined ? '' : relocationModel.lastName : '';
        this.companyName = relocationModel ? relocationModel.companyName == undefined ? '' : relocationModel.companyName : '';
        this.companyRegNo = relocationModel ? relocationModel.companyRegNo == undefined ? '' : relocationModel.companyRegNo : '';
        this.said = relocationModel ? relocationModel.said == undefined ? '' : relocationModel.said : '';
        this.customerTypeId = relocationModel ? relocationModel.customerTypeId == undefined ? '' : relocationModel.customerTypeId : '';
        this.contactId = relocationModel ? relocationModel.contactId == undefined ? '' : relocationModel.contactId : '';
        this.createdUserId = relocationModel ? relocationModel.createdUserId == undefined ? '' : relocationModel.createdUserId : '';
        this.transferDate = relocationModel ? relocationModel.transferDate == undefined ? '' : relocationModel.transferDate : '';
        this.reason = relocationModel ? relocationModel.reason == undefined ? '' : relocationModel.reason : '';
        this.movingDate = relocationModel ? relocationModel.movingDate == undefined ? '' : relocationModel.movingDate : '';
    }
    addressConfidentLevelId: string;
    addressConfidentLevelName: string;
    cityId: string;
    provinceId: string;
    leadGroupId: string;
    suburbId: string;
    titleId: string;
    firstName: string;
    lastName: string;
    companyName: string;
    companyRegNo: string;
    said: string;
    customerTypeId: string;
    contactId: string;
    createdUserId: string;
    seoId: string;
    provinceName?: string;
    siteTypeId: string;
    sourceId: string;
    addressConfidentLevel: string;
    IsLSSScheme: boolean;
    estateName: string;
    leadCategoryId: string;
    estateStreetNo: string;
    estateStreetName: string;
    cityName?: string;
    postalCode?: string;
    buildingName?: string;
    buildingNumber?: string;
    suburbName?: string;
    locationPin?: string;
    streetName?: string;
    streetNo?: string;
    addressId?: string;
    transferDate?: string;
    reason?: string;
    movingDate?: string;
    isAddressComplex?: boolean;
    isAddressExtra?: boolean;
    isAfrigisSearch?: boolean;
    reprovince?: string;
    recity?: string;
    repostalCode?: string;
    rebuildingName?: string;
    rebuildingNumber?: string;
    resuburb?: string;
    relocationPin?: string;
    restreetAddress?: string;
    restreetNumber?: string;
    formatedAddress?: string;
    readdressId?: string;
    currentAddressItems?: [];
    NewAddressItems?: [];
    currentAddressId?: string;
    newAddressId?: string;
    customerId?: string;
}

export { RelocationModel, UpgradeModel };

